// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectTradingSignalMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_TRADING_SIGNAL_MESSAGE)

    this.NotSeen = false;      // поле приходит только если true, потому задам по умолчанию false

    this.Title = null;
    this.Description = null;

    this.TradingSignalId = null;
    this.TradingSystemId = null;

    this.OpenPrice = null;
    this.OrderType = null;
    this.OperationType = null;
    this.Tif = null;
    this.TifExpireAt = null;
    this.TradableInstrumentId = null;
    this.RouteId = null;
    this.ProductType = null;

    this.SLPrice = null;
    this.SLLPrice = null;
    this.TPPrice = null;
    this.SLPriceType = null;
    this.TPPriceType = null;

    this.CreateTime = null;
    this.ExpireTime = null;

    this.AttachmentScreenPath = null;
    this.AttachmentFilePath = null;
}

DirectTradingSignalMessage.prototype = Object.create(DirectMessageBase.prototype)